<script>
    import { onMount } from "svelte";

    import {
        user,
        loggedInDoctorDetail,
        preventRedirect,
        preventRedirectObj,
    } from "../../stores";

    import { PageHead } from "../../Components/Common/index.svelte";

    import CreateSection from "./components/CreateSection.svelte";
    import EditSection from "./components/EditSection.svelte";
    import { backToList, goBack } from "../../Utils/utilFunctions.svelte";

    export let params = {};

    let isCreateFlow = false,
        isEditDuplicate = false,
        isDuplicateFromTable = true,
        patientDetails = {},
        patientEncounterDetails = {};

    $: if (params && params.id) isCreateFlow = false;
    else isCreateFlow = true;

    $: isFlowEnableSearchDoctor =
        $user.role == 100 || $user.role == 80 || $user.role == 20;

    $: if (!isCreateFlow) isEditDuplicate = !!params.query ?? false;

    $: if (isEditDuplicate)
        isDuplicateFromTable = params.query.split("=")[1] == 1;

    onMount(() => {});

    const updatePatientDetails = (res) => {
        patientDetails = { ...res };
    };

    const updatePatientEncounterDetails = (res) => {
        patientEncounterDetails = { ...res };
    };

    $: pageHeadTitle = isCreateFlow
        ? $user.role == 2
            ? "Create Patient Encounter"
            : isFlowEnableSearchDoctor
              ? $loggedInDoctorDetail.id
                  ? `Create Patient Encounter for ${$loggedInDoctorDetail.fullName}`
                  : "Create Patient Encounter"
              : "Create Patient Encounter"
        : `${isEditDuplicate ? "Duplicate" : "Edit"} Patient Encounter`;
</script>

<PageHead
    title={pageHeadTitle}
    backFunc={() => {
        if (!$preventRedirect) goBack();
        else {
            $preventRedirectObj.showModal = true;
        }
    }}
/>

<div class="relative flex-1 overflow-y-auto">
    <div class="absolute inset-0 flex-1">
        {#if isCreateFlow}
            <CreateSection
                {params}
                {updatePatientDetails}
                {updatePatientEncounterDetails}
            />
        {:else}
            <EditSection
                {isEditDuplicate}
                {isDuplicateFromTable}
                patientEncounterId={params.id}
                {updatePatientDetails}
                {updatePatientEncounterDetails}
            />
        {/if}
    </div>
</div>
